import { NO_DATA_MESSAGE, PersonHttpHelper } from '../../utils/HttpHelper';

const getPersonContact = (personId, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      message: 'Loading contact information...'
    };
    setState(newState);
    
    const url = `/PersonContact/GetSelfInfo`;
    
    PersonHttpHelper(url, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  }
};

const updatePersonContact = (personId, contactData, state, setState) => {
  if (state.isObjLoading !== true) {
    const newState = {
      ...state,
      isObjLoading: true,
      message: 'Updating contact information...'
    };
    setState(newState);
    
    const url = `/PersonContact/UpdateSelfInfo`;
    
    PersonHttpHelper(url, 'POST', contactData)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  }
};

const confirmPersonContact = (personId, state, setState) => {
  if (state.isObjLoading !== true) {
    const newState = {
      ...state,
      isObjLoading: true,
      message: 'Confirming contact information...'
    };
    setState(newState);
    
    const url = `/PersonContact/ConfirmContactInfo`;
    
    PersonHttpHelper(url, 'POST', {})
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  }
};

export { getPersonContact, updatePersonContact, confirmPersonContact };
export default getPersonContact;